/**
 * Gestor de Tags con Choices.js
 * Permite seleccionar etiquetas existentes y crear nuevas al presionar Enter
 * @author Desarrollador Senior
 * @version 2.0
 */

$(function () {
    const tagSelectElement = document.getElementById("cont_tags");
    const MAX_TAGS = Number(tagSelectElement?.dataset?.maxItems || 10);
    const MAX_TAG_LENGTH = Number(tagSelectElement?.dataset?.maxLength || 50);

    if (!tagSelectElement) return;

    // Configuración de Choices.js
    const choicesInstance = new Choices(tagSelectElement, {
        removeItemButton: true,
        duplicateItemsAllowed: false,
        delimiter: ",",
        editItems: true,
        addItems: true,
        maxItemCount: MAX_TAGS,

        // Textos personalizados en español
        placeholderValue: "Escribe y presiona Enter para agregar etiquetas...",
        searchPlaceholderValue: "Buscar o agregar nueva etiqueta...",
        noResultsText: "Presiona Enter para crear esta etiqueta.",
        noChoicesText: "Escribe y presiona Enter para crear etiquetas",
        itemSelectText: "",
        addItemText: (value) => {
            return `Presiona <strong>Enter</strong> para agregar "<strong>${value}</strong>"`;
        },

        // Permitir agregar cualquier valor como nuevo item
        addItemFilter: (value) => {
            if (!value || value.trim() === "") return false;

            const trimmedValue = value.trim();
            const currentValues = choicesInstance.getValue(true);

            if (currentValues.length >= MAX_TAGS) return false;
            if (trimmedValue.length > MAX_TAG_LENGTH) return false;

            // Validar duplicados (case-insensitive)
            const isDuplicate = currentValues.some(
                (item) => item.toLowerCase() === trimmedValue.toLowerCase()
            );

            return isDuplicate ? false : trimmedValue;
        },

        searchEnabled: true,
        searchFloor: 1,
        position: "auto",
    });

    // Evento: Limpiar input después de agregar una etiqueta
    tagSelectElement.addEventListener("addItem", function (event) {
        console.log("Etiqueta agregada:", event.detail);
    });

    // Forzar que Enter agregue el valor escrito como nuevo item
    const choicesInput = tagSelectElement.parentElement.querySelector(
        ".choices__input--cloned"
    );
    if (choicesInput) {
        choicesInput.maxLength = MAX_TAG_LENGTH;
        choicesInput.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                const inputValue = e.target.value.trim();

                if (inputValue && inputValue.length > 0) {
                    // Prevenir el comportamiento por defecto
                    e.preventDefault();
                    e.stopPropagation();

                    // Verificar duplicados
                    const currentValues = choicesInstance.getValue(true);
                    const isDuplicate = currentValues.some(
                        (item) =>
                            item.toLowerCase() === inputValue.toLowerCase()
                    );

                    if (!isDuplicate) {
                        if (currentValues.length >= MAX_TAGS) {
                            if (window.Swal && typeof window.Swal.fire === "function") {
                                window.Swal.fire({
                                    icon: "warning",
                                    title: "Límite de etiquetas",
                                    text: `Solo puedes agregar máximo ${MAX_TAGS} etiquetas.`,
                                });
                            }
                            return;
                        }

                        if (inputValue.length > MAX_TAG_LENGTH) {
                            if (window.Swal && typeof window.Swal.fire === "function") {
                                window.Swal.fire({
                                    icon: "warning",
                                    title: "Etiqueta muy larga",
                                    text: `Cada etiqueta permite máximo ${MAX_TAG_LENGTH} caracteres.`,
                                });
                            }
                            return;
                        }

                        // Agregar el valor como nuevo item
                        choicesInstance.setValue([
                            {
                                value: inputValue,
                                label: inputValue,
                                selected: true,
                            },
                        ]);

                        // Limpiar el input
                        e.target.value = "";
                        choicesInstance.hideDropdown();
                    } else {
                        console.warn("La etiqueta ya existe:", inputValue);
                    }
                }
            }
        });
    }
});
